import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthSimpleLayout from './AuthSimpleLayout';
import is from 'is_js';
import MainLayout from './MainLayout';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import SettingsPanel from 'components/settings-panel/SettingsPanel';

import ErrorLayout from './ErrorLayout';
import WizardAuth from 'components/authentication/wizard/WizardAuth';
import Landing from 'components/pages/landing/Landing';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';

import Accordion from 'components/doc-components/Accordion';
import Alerts from 'components/doc-components/Alerts';
import Badges from 'components/doc-components/Badges';
import Breadcrumbs from 'components/doc-components/Breadcrumb';
import Buttons from 'components/doc-components/Buttons';
import CalendarExample from 'components/doc-components/CalendarExample';
import Cards from 'components/doc-components/Cards';
import Dropdowns from 'components/doc-components/Dropdowns';
import ListGroups from 'components/doc-components/ListGroups';
import Modals from 'components/doc-components/Modals';
import Offcanvas from 'components/doc-components/Offcanvas';
import Pagination from 'components/doc-components/Pagination';
import BasicProgressBar from 'components/doc-components/ProgressBar';
import Spinners from 'components/doc-components/Spinners';
import Toasts from 'components/doc-components/Toasts';
import Avatar from 'components/doc-components/Avatar';
import Image from 'components/doc-components/Image';
import Tooltips from 'components/doc-components/Tooltips';
import Popovers from 'components/doc-components/Popovers';
import Figures from 'components/doc-components/Figures';
import Hoverbox from 'components/doc-components/Hoverbox';
import Tables from 'components/doc-components/Tables';
import FormControl from 'components/doc-components/FormControl';
import InputGroup from 'components/doc-components/InputGroup';
import Select from 'components/doc-components/Select';
import Checks from 'components/doc-components/Checks';
import Range from 'components/doc-components/Range';
import FormLayout from 'components/doc-components/FormLayout';
import FloatingLabels from 'components/doc-components/FloatingLabels';
import FormValidation from 'components/doc-components/FormValidation';
import BootstrapCarousel from 'components/doc-components/BootstrapCarousel';
import SlickCarousel from 'components/doc-components/SlickCarousel';
import Navs from 'components/doc-components/Navs';
import Navbars from 'components/doc-components/Navbars';
import Tabs from 'components/doc-components/Tabs';
import Collapse from 'components/doc-components/Collapse';
import CountUp from 'components/doc-components/CountUp';
import Embed from 'components/doc-components/Embed';
import Background from 'components/doc-components/Backgrounds';
import Search from 'components/doc-components/Search';
import VerticalNavbar from 'components/doc-components/VerticalNavbar';
import NavBarTop from 'components/doc-components/NavBarTop';
import ComboNavbar from 'components/doc-components/ComboNavbar';
import TypedText from 'components/doc-components/TypedText';
import FileUploader from 'components/doc-components/FileUploader';
import Borders from 'components/utilities/Borders';
import Colors from 'components/utilities/Colors';
import ColoredLinks from 'components/utilities/ColoredLinks';
import Display from 'components/utilities/Display';
import Visibility from 'components/utilities/Visibility';
import StretchedLink from 'components/utilities/StretchedLink';
import Float from 'components/utilities/Float';
import Position from 'components/utilities/Position';
import Spacing from 'components/utilities/Spacing';
import Sizing from 'components/utilities/Sizing';
import TextTruncation from 'components/utilities/TextTruncation';
import Typography from 'components/utilities/Typography';
import VerticalAlign from 'components/utilities/VerticalAlign';
import Flex from 'components/utilities/Flex';
import Grid from 'components/utilities/Grid';
import WizardForms from 'components/doc-components/WizardForms';
import GettingStarted from 'components/documentation/GettingStarted';
import Configuration from 'components/documentation/Configuration';
import DarkMode from 'components/documentation/DarkMode';
import Plugins from 'components/documentation/Plugins';
import Styling from 'components/documentation/Styling';
import DesignFile from 'components/documentation/DesignFile';
import Starter from 'components/pages/Starter';
import AnimatedIcons from 'components/doc-components/AnimatedIcons';
import DatePicker from 'components/doc-components/DatePicker';
import FontAwesome from 'components/doc-components/FontAwesome';
import Changelog from 'components/documentation/change-log/ChangeLog';
import Analytics from 'components/dashboards/analytics';
import Crm from 'components/dashboards/crm';
import Saas from 'components/dashboards/saas';
import Profile from 'components/pages/user/profile/Profile';
import Associations from 'components/pages/asscociations/Associations';
import Followers from 'components/app/social/followers/Followers';
import Directory from 'components/app/directory/Directory';
import OrgChart from 'components/app/directory/OrgChart';
import UserForm from 'components/app/directory/UserForm';
import UserDetails from '../components/app/directory/UserDetails';
import DirectoryProfile from 'components/app/directory/DirectoryProfile';
import HolidaysCalendar from 'components/app/holidays/HolidaysCalendar';
import Holidays from 'components/app/holidays/Holidays';
import Documents from 'components/app/documents/Documents';
import Notifications from 'components/app/social/notifications/Notifications';
import ActivityLog from 'components/app/social/activity-log/ActivityLog';
import BSTSettings from 'components/app/directory/BSTSettings';
import Feed from 'components/app/social/feed/Feed';
import Placeholder from 'components/doc-components/Placeholder';
import Lightbox from 'components/doc-components/Lightbox';
import AdvanceTableExamples from 'components/doc-components/AdvanceTableExamples';
import ModalAuth from 'components/authentication/modal/ModalAuth';
import Calendar from 'components/app/calendar/Calendar';
import FaqAlt from 'components/pages/faq/faq-alt/FaqAlt';
import FaqBasic from 'components/pages/faq/faq-basic/FaqBasic';
import FaqAccordion from 'components/pages/faq/faq-accordion/FaqAccordion';
import PrivacyPolicy from 'components/pages/miscellaneous/privacy-policy/PrivacyPolicy';
import InvitePeople from 'components/pages/miscellaneous/invite-people/InvitePeople';
import PricingDefault from 'components/pages/pricing/pricing-default/PricingDefault';
import PricingAlt from 'components/pages/pricing/pricing-alt/PricingAlt';
import Invoice from 'components/app/e-commerce/Invoice';
import Billing from 'components/app/e-commerce/billing/Billing';
import Checkout from 'components/app/e-commerce/checkout/Checkout';
import ShoppingCart from 'components/app/e-commerce/cart/ShoppingCart';
import CustomersDetails from 'components/app/e-commerce/customers-details/CustomersDetails';
import OrderDetails from 'components/app/e-commerce/orders/order-details/OrderDetails';
import Products from 'components/app/e-commerce/product/Products';
import ProductDetails from 'components/app/e-commerce/product/product-details/ProductDetails';
import Orders from 'components/app/e-commerce/orders/order-list/Orders';
import Customers from 'components/app/e-commerce/customers/Customers';
import CreateEvent from 'components/app/events/create-an-event/CreateEvent';
import EventList from 'components/app/events/event-list/EventList';
import EventDetail from 'components/app/events/event-detail/EventDetail';
import EmailDetail from 'components/app/email/email-detail/EmailDetail';
import Compose from 'components/app/email/compose/Compose';
import Inbox from 'components/app/email/inbox/Inbox';
import Rating from 'components/doc-components/Rating';
import AdvanceSelect from 'components/doc-components/AdvanceSelect';
import Editor from 'components/doc-components/Editor';
import Chat from 'components/app/chat/Chat';
import Kanban from 'components/app/kanban/Kanban';
import DraggableExample from 'components/doc-components/DraggableExample';
import LineCharts from 'components/doc-components/charts-example/echarts/line-charts';
import BarCharts from 'components/doc-components/charts-example/echarts/bar-charts';
import CandlestickCharts from 'components/doc-components/charts-example/echarts/candlestick-charts';
import GeoMaps from 'components/doc-components/charts-example/echarts/geo-map';
import ScatterCharts from 'components/doc-components/charts-example/echarts/scatter-charts';
import PieCharts from 'components/doc-components/charts-example/echarts/pie-charts';
import RadarCharts from 'components/doc-components/charts-example/echarts/radar-charts/Index';
import HeatmapCharts from 'components/doc-components/charts-example/echarts/heatmap-chart';
import Chartjs from 'components/doc-components/charts-example/chartjs';
import HowToUse from 'components/doc-components/charts-example/echarts/HowToUse';
import GoogleMapExample from 'components/doc-components/GoogleMapExample';
import LeafletMapExample from 'components/doc-components/LeafletMapExample';
import CookieNoticeExample from 'components/doc-components/CookieNoticeExample';
import Scrollbar from 'components/doc-components/Scrollbar';
import Scrollspy from 'components/doc-components/Scrollspy';
import ReactIcons from 'components/doc-components/ReactIcons';
import ReactPlayerExample from 'components/doc-components/ReactPlayerExample';
import EmojiMartExample from 'components/doc-components/EmojiMart';
import TreeviewExample from 'components/doc-components/TreeviewExample';
import Timeline from 'components/doc-components/Timeline';
import Widgets from 'widgets/Widgets';
import Ecommerce from 'components/dashboards/e-commerce';
import ProjectManagement from 'components/dashboards/project-management';

import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import SimpleLogin from 'components/authentication/simple/Login';
import SimpleLogout from 'components/authentication/simple/Logout';
import SimpleRegistration from 'components/authentication/simple/Registration';
import SimpleForgetPassword from 'components/authentication/simple/ForgetPassword';
import SimplePasswordReset from 'components/authentication/simple/PasswordReset';
import SimpleConfirmMail from 'components/authentication/simple/ConfirmMail';
import SimpleLockScreen from 'components/authentication/simple/LockScreen';

import CardLogin from 'components/authentication/card/Login';
import Logout from 'components/authentication/card/Logout';
import CustomLogout from 'components/app/common/Logout';
import CardRegistration from 'components/authentication/card/Registration';
import CardForgetPassword from 'components/authentication/card/ForgetPassword';
import CardConfirmMail from 'components/authentication/card/ConfirmMail';
import CardPasswordReset from 'components/authentication/card/PasswordReset';
import CardLockScreen from 'components/authentication/card/LockScreen';

import SplitLogin from 'components/authentication/split/Login';
import SplitLogout from 'components/authentication/split/Logout';
import SplitRegistration from 'components/authentication/split/Registration';
import SplitForgetPassword from 'components/authentication/split/ForgetPassword';
import SplitPasswordReset from 'components/authentication/split/PasswordReset';
import SplitConfirmMail from 'components/authentication/split/ConfirmMail';
import SplitLockScreen from 'components/authentication/split/LockScreen';

import Wizard from 'components/wizard/Wizard';

import HRDashboard from '../components/dashboards/hr';
import AppContext from 'context/Context';
import Faq from 'components/documentation/Faq';
import RegistrationForm from 'components/app/directory/RegistrationForm';
import RolePositionForm from 'components/app/rolepositions/RolePositionForm';
import RolePositionDetails from 'components/app/rolepositions/RolePositionDetails';
import BudgetLandingPage from '../components/app/budget/BudgetLandingPage';
import ExpensesLandingPage from '../components/app/expenses/ExpensesLandingPage';
import InvoicesLandingPage from '../components/app/invoices/InvoicesLandingPage';
import InvoiceDetails from '../components/app/invoices/InvoiceDetails';

import ManagementEventForm from '../components/app/management-events/event-form/ManagementEventForm';
import ManagementEventDetails from 'components/app/management-events/event-form/ManagementEventDetails';
import CompleteRegistration from '../components/app/common/CompleteRegistration';
import OneStepRegistrationForm from 'components/app/directory/OneStepRegistrationForm';
import HolidayForm from 'components/app/holidays/HolidayForm';
import CustomList from 'components/app/custom-object/CustomList';
import CustomDetails from 'components/app/custom-object/CustomDetails';
import CustomForm from 'components/app/custom-object/CustomForm';
import CustomLandingPage from 'components/app/custom-object/CustomLandingPage';

import PerformanceManagementLandingPage from 'components/app/performance-management/PerformanceManagementLandingPage';
import PerformanceReviewForm from 'components/app/performance-management/PerformanceReviewForm';
import GoalForm from 'components/app/performance-management/GoalForm';
import GoalList from 'components/app/performance-management/GoalList';
import MyDetails from 'components/app/directory/MyDetails';
import UsersLandingPage from 'components/app/directory/UsersLandingPage';
import RolePositionLandingPage from 'components/app/rolepositions/RolePositionLandingPage';
import NotificationList from 'components/app/notifications/NotificationList';
import LeadList from 'components/app/leads/LeadList';
import LeadForm from 'components/app/leads/LeadForm';
import LeadDetails from 'components/app/leads/LeadDetails';
import HolidayDetails from 'components/app/holidays/HolidayDetails';
import AnnoucementForm from 'components/app/annoucements/AnnoucementForm';
import AnnoucementList from 'components/app/annoucements/AnnoucementList';
import AnnoucementDetails from 'components/app/annoucements/AnnoucementDetails';
import ImportUsersPage from 'components/app/directory/ImportUsersPage';
import GroupList from 'components/app/groups/GroupList';
import GroupDetails from 'components/app/groups/GroupDetails';
import GroupForm from 'components/app/groups/GroupForm';
import SupportTicketList from 'components/app/support-tickets/SupportTicketList';
import SupportTicketDetails from 'components/app/support-tickets/SupportTicketDetails';
import SupportTicketForm from 'components/app/support-tickets/SupportTicketForm';
import EquipmentForm from 'components/app/equipments/EquipmentForm';
import SalaryLevelForm from 'components/app/rolepositions/salarylevels/SalaryLevelForm';
import SalaryLevelList from 'components/app/rolepositions/salarylevels/SalaryLevelList';
import SalaryLevelDetails from 'components/app/rolepositions/salarylevels/SalaryLevelDetails';
import AccountDetails from 'components/app/directory/user-details/AccountDetails';
import ImportLeadsPage from 'components/app/leads/ImportLeadsPage';
import PayrollLandingPage from 'components/app/payroll/PayrollLandingPage';
import FeedbackForm from 'components/app/performance-management/FeedbackForm';
import FeedbackRequestForm from 'components/app/performance-management/FeedbackRequestForm';
import FeedbackList from 'components/app/performance-management/FeedbackList';
import CandidateList from 'components/app/rolepositions/CandidateList';
import CandidateForm from 'components/app/rolepositions/CandidateForm';
import AccountList from 'components/app/account/AccountList';
import AccountForm from 'components/app/account/AccountForm';
import RootAccountDetails from 'components/app/account/AccountDetails';
import OnboardingDashboard from 'components/dashboards/hr/OnboardingDashboard';
import SoftwareLicenceForm from 'components/app/software-licences/SoftwareLicenceForm';
import SoftwareLicenceDetails from 'components/app/software-licences/SoftwareLicenceDetails';
import SoftwareLicenceList from 'components/app/software-licences/SoftwareLicenceList';
import HRUKRecruiter from 'components/app/ai-tools/HRUKRecruiter';
import ContactList from 'components/app/contacts/ContactList';
import ContactDetails from 'components/app/contacts/ContactDetails';
import ContactForm from 'components/app/contacts/ContactForm';
import Timetable from 'components/app/wod/Timetable';

import RoomDetails from 'components/app/hospitality/rooms/RoomDetails';
import RoomForm from 'components/app/hospitality/rooms/RoomForm';
import RoomList from 'components/app/hospitality/rooms/RoomList';
import WodLandingPage from 'components/app/wod/WodLandingPage';
import ProgramLandingPage from 'components/app/wod/programs/ProgramLandingPage';
import ProgramDetails from 'components/app/wod/programs/ProgramDetails';
import ProgramForm from 'components/app/wod/programs/ProgramForm';
import GenerateProgramAI from 'components/app/wod/programs/GenerateProgramAI';
import ProgrammingForm from 'components/app/wod/programming/ProgrammingForm';
import BookingsTable from 'components/app/wod/bookings/BookingsTable';
import TrainingHistoryList from 'components/app/wod/history/TrainingHistoryList';
import MembershipsLandingPage from 'components/app/wod/memberships/MembershipsLandingPage';
import TemplateTable from 'components/app/wod/templates/TemplateTable';
import TemplateDetails from 'components/app/wod/templates/TemplateDetails';
import TemplateForm from 'components/app/wod/templates/TemplateForm';
import ConnectStripe from 'components/app/wod/payments/ConnectStripe';
import WODProfileDetails from 'components/app/wod/my-details/WODProfileDetails';
import PaymentLandingPage from 'components/app/wod/payments/PaymentLandingPage';
import WODProductForm from 'components/app/wod/payments/WODProductForm';
import WODProductDetails from 'components/app/wod/payments/WODProductDetails';
import AthleteForm from 'components/app/wod/payments/AthleteForm';
import PersonalRecords from 'components/app/wod/personal-records/PersonalRecords';
import WODGoalTable from 'components/app/wod/goals/WODGoalTable';
import WODGoalForm from 'components/app/wod/goals/WODGoalForm';
import WODGoalDetails from 'components/app/wod/goals/WODGoalDetails';
import WODMembers from 'components/app/wod/members/WODMembers';
import ImportWODMembersPage from 'components/app/wod/members/ImportWODMembersPage';
import WODClassTable from 'components/app/wod/classes/WODClassTable';
import WODClassDetails from 'components/app/wod/classes/WODClassDetails';
import WODClassForm from 'components/app/wod/classes/WODClassForm';
import PaymentSuccess from 'components/app/wod/payments/PaymentSuccess';
import PaymentCancel from 'components/app/wod/payments/PaymentCancel';  
import ImportWODMembersHistoryPage from 'components/app/wod/members/ImportWODMembersHistoryPage';
import WODMyDetails from 'components/app/wod/my-details/WODMyDetails';
import UpcomingBirthdaysTable from 'components/app/directory/UpcomingBirthdaysTable';
import ImportWODTemplates from 'components/app/wod/templates/ImportWODTemplates';
import LeaderboardTable from 'components/app/wod/classes/LeaderboardTable';
const Layout = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  useContext(AppContext);
  const isWOD = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (!profile) {
      return '/';
    }
    const wodRoles = ['WOD', 'WOD-ADMIN'];
    const profileRoles = profile.roles;

    const isWOD = wodRoles.some(item2 =>
      profileRoles.some(item1 => item1.key === item2)
    );

    return isWOD;
  };
  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
  }, [HTMLClassList]);

  return (
    <>
      <Routes>
        <Route path="landing" element={<Landing />} />
        <Route element={<ErrorLayout />}>
          <Route path="errors/404" element={<Error404 />} />
          <Route path="errors/500" element={<Error500 />} />
        </Route>
        <Route
          path="authentication/registration-form"
          element={<RegistrationForm />}
        />
        <Route path="/registration" element={<OneStepRegistrationForm />} />
        <Route
          path="authentication/complete-registration"
          element={<CompleteRegistration />}
        />
        {/*- ------------- Authentication ---------------------------  */}

        {/*- ------------- simple ---------------------------  */}
        <Route element={<AuthSimpleLayout />}>
          <Route path="authentication/simple/login" element={<SimpleLogin />} />
          <Route
            path="authentication/simple/register"
            element={<SimpleRegistration />}
          />
          <Route
            path="authentication/simple/logout"
            element={<SimpleLogout />}
          />

          <Route
            path="authentication/simple/forgot-password"
            element={<SimpleForgetPassword />}
          />
          <Route
            path="authentication/simple/reset-password"
            element={<SimplePasswordReset />}
          />
          <Route
            path="authentication/simple/confirm-mail"
            element={<SimpleConfirmMail />}
          />
          <Route
            path="authentication/simple/lock-screen"
            element={<SimpleLockScreen />}
          />
        </Route>

        {/*- ------------- Card ---------------------------  */}
        <Route path="authentication/card/login" element={<CardLogin />} />
        {/*- ------------- Ai Free Access ---------------------------  */}
        <Route
          path="tools/ai/hr-expert-recruiter"
          element={<HRUKRecruiter />}
        />
        <Route
          path="authentication/card/register"
          element={<CardRegistration />}
        />
        <Route path="authentication/card/logout" element={<Logout />} />
        <Route path="app/common/logout" element={<CustomLogout />} />
        <Route
          path="authentication/card/forgot-password"
          element={<CardForgetPassword />}
        />
        <Route
          path="authentication/card/reset-password"
          element={<CardPasswordReset />}
        />
        <Route
          path="authentication/card/confirm-mail"
          element={<CardConfirmMail />}
        />
        <Route
          path="authentication/card/lock-screen"
          element={<CardLockScreen />}
        />

        {/*- ------------- Split ---------------------------  */}

        <Route path="authentication/split/login" element={<SplitLogin />} />
        <Route path="authentication/split/logout" element={<SplitLogout />} />
        <Route
          path="authentication/split/register"
          element={<SplitRegistration />}
        />
        <Route
          path="authentication/split/forgot-password"
          element={<SplitForgetPassword />}
        />
        <Route
          path="authentication/split/reset-password"
          element={<SplitPasswordReset />}
        />
        <Route
          path="authentication/split/confirm-mail"
          element={<SplitConfirmMail />}
        />
        <Route
          path="authentication/split/lock-screen"
          element={<SplitLockScreen />}
        />

        <Route element={<WizardAuth />}>
          <Route
            path="authentication/wizard"
            element={<Wizard validation={true} />}
          />
        </Route>

        {/* //--- MainLayout Starts  */}

        <Route element={<MainLayout />}>
          {/*Dashboard*/}
          <Route
            path="/"
            element={!isWOD ? <HRDashboard /> : <WodLandingPage />}
          />
          <Route path="dashboard/analytics" element={<Analytics />} />
          <Route path="dashboard/crm" element={<Crm />} />
          <Route path="dashboard/saas" element={<Saas />} />
          <Route path="dashboard/e-commerce" element={<Ecommerce />} />
          <Route
            path="dashboard/project-management"
            element={<ProjectManagement />}
          />
          {/* E Commerce */}
          <Route
            path="e-commerce/orders/order-details"
            element={<OrderDetails />}
          />
          <Route path="e-commerce/orders/order-list" element={<Orders />} />
          <Route path="e-commerce/invoice" element={<Invoice />} />
          <Route path="e-commerce/billing" element={<Billing />} />
          <Route path="e-commerce/checkout" element={<Checkout />} />
          <Route path="e-commerce/shopping-cart" element={<ShoppingCart />} />
          <Route path="e-commerce/customers" element={<Customers />} />
          <Route
            path="e-commerce/customer-details"
            element={<CustomersDetails />}
          />
          <Route
            path="e-commerce/product/product-details"
            element={<ProductDetails />}
          />
          <Route
            path="e-commerce/product/product-details/:productId"
            element={<ProductDetails />}
          />
          <Route
            path="e-commerce/product/:productLayout"
            element={<Products />}
          />
          <Route path="e-commerce/invoice" element={<Invoice />} />
          {/*icons*/}
          <Route path="icons/font-awesome" element={<FontAwesome />} />
          <Route path="icons/react-icons" element={<ReactIcons />} />
          {/* maps */}
          <Route path="maps/google-map" element={<GoogleMapExample />} />
          <Route path="maps/leaflet-map" element={<LeafletMapExample />} />
          {/*App*/}
          <Route path="app/calendar" element={<Calendar />} />
          <Route path="app/chat" element={<Chat />} />
          <Route path="app/kanban" element={<Kanban />} />
          <Route path="social/feed" element={<Feed />} />
          <Route path="social/activity-log" element={<ActivityLog />} />
          <Route path="social/notifications" element={<Notifications />} />
          <Route path="social/followers" element={<Followers />} />
          <Route path="social/directory" element={<Directory />} />
          <Route path="social/directory/org-chart" element={<OrgChart />} />
          <Route
            path="social/directory/user-list"
            element={<UsersLandingPage />}
          />
          <Route
            path="social/directory/user/import"
            element={<ImportUsersPage />}
          />
          <Route path="social/directory/user-form" element={<UserForm />} />
          <Route
            path="social/directory/user-details"
            element={<UserDetails />}
          />
          <Route
            path="social/directory/user-details/:identifier"
            element={<UserDetails />}
          />
          <Route path="social/directory/my-details" element={<MyDetails />} />
          <Route
            path="social/directory/user-form/:identifier"
            element={<UserForm />}
          />
          <Route path="app/onboarding" element={<OnboardingDashboard />} />
          <Route
            path="social/directory/profile/:identifier"
            element={<DirectoryProfile />}
          />
          <Route path="app/roles" element={<RolePositionLandingPage />} />
          <Route path="app/roles/role-form" element={<RolePositionForm />} />
          <Route
            path="app/roles/:identifier"
            element={<RolePositionDetails />}
          />
          <Route
            path="app/roles/:identifier/edit"
            element={<RolePositionForm />}
          />
          <Route
            path="app/roles/salarylevels/create-form"
            element={<SalaryLevelForm />}
          />
          <Route path="app/roles/salarylevels" element={<SalaryLevelList />} />
          <Route
            path="app/roles/salarylevels/:identifier"
            element={<SalaryLevelDetails />}
          />
          <Route
            path="app/roles/salarylevels/:identifier/edit"
            element={<SalaryLevelForm />}
          />
          <Route path="app/roles/candidates" element={<CandidateList />} />
          <Route
            path="app/candidates/create-form"
            element={<CandidateForm />}
          />
          <Route
            path="app/candidates/:identifier/edit"
            element={<CandidateForm />}
          />
          <Route path="app/notifications" element={<NotificationList />} />
          <Route path="app/holidays" element={<Holidays />} />
          <Route path="app/holidays/calendar" element={<HolidaysCalendar />} />
          <Route
            path="app/holidays/:identifier/edit"
            element={<HolidayForm />}
          />
          <Route path="app/holidays/:identifier" element={<HolidayDetails />} />
          <Route path="app/holidays/create-form" element={<HolidayForm />} />
          <Route
            path="app/software-licences/create-form"
            element={<SoftwareLicenceForm />}
          />
          <Route
            path="app/software-licences/:identifier/edit"
            element={<SoftwareLicenceForm />}
          />
          <Route
            path="app/software-licences/:identifier"
            element={<SoftwareLicenceDetails />}
          />
          <Route
            path="app/software-licences"
            element={<SoftwareLicenceList />}
          />
          <Route path="app/documents" element={<Documents />} />
          <Route
            path="management-events/:identifier/edit"
            element={<ManagementEventForm />}
          />
          <Route path="app/payroll" element={<PayrollLandingPage />} />
          <Route path="app/leads" element={<LeadList />} />
          <Route path="app/leads/:identifier" element={<LeadDetails />} />
          <Route path="app/leads/:identifier/edit" element={<LeadForm />} />
          <Route path="app/leads/create-form" element={<LeadForm />} />
          <Route path="app/leads/import" element={<ImportLeadsPage />} />
          <Route
            path="management-events/:identifier"
            element={<ManagementEventDetails />}
          />
          <Route path="app/groups" element={<GroupList />} />
          <Route path="app/groups/:identifier" element={<GroupDetails />} />
          <Route path="app/groups/:identifier/edit" element={<GroupForm />} />
          <Route path="app/groups/create-form" element={<GroupForm />} />
          /app/contacts
          <Route path="app/contacts" element={<ContactList />} />
          <Route path="app/contacts/:identifier" element={<ContactDetails />} />
          <Route
            path="app/contacts/:identifier/edit"
            element={<ContactForm />}
          />
          <Route path="app/contacts/create-form" element={<ContactForm />} />
          <Route path="app/hospitality/rooms" element={<RoomList />} />
          <Route
            path="app/hospitality/rooms/:identifier"
            element={<RoomDetails />}
          />
          <Route
            path="app/hospitality/rooms/:identifier/edit"
            element={<RoomForm />}
          />
          <Route
            path="app/hospitality/rooms/create-form"
            element={<RoomForm />}
          />
          <Route path="app/wod/dashboard" element={<WodLandingPage />} />
          <Route path="app/wod/programs" element={<ProgramLandingPage />} />
          <Route
            path="app/wod/programs/:identifier"
            element={<ProgramDetails />}
          />
          <Route
            path="app/wod/programs/:identifier/edit"
            element={<ProgramForm />}
          />
          <Route
            path="app/wod/programs/create-ai-form"
            element={<GenerateProgramAI />}
          />          
          <Route
            path="app/wod/programs/create-form"
            element={<ProgramForm />}
          />
          <Route path="app/wod/timetable" element={<Timetable />} />
          <Route path="app/wod/programming" element={<ProgrammingForm />} />
          <Route path="app/wod/bookings" element={<BookingsTable />} />
          <Route path="app/wod/admin/classes" element={<WODClassTable />} />
          <Route
            path="app/wod/admin/classes/:identifier"
            element={<WODClassDetails />}
          />
          <Route
            path="app/wod/birthdays"
            element={<UpcomingBirthdaysTable />} />
          <Route
            path="app/wod/admin/classes/:identifier/edit"
            element={<WODClassForm />}
          />
          <Route
            path="app/wod/admin/classes/create-form"
            element={<WODClassForm />}
          />
          <Route path="app/wod/leaderboard" element={<LeaderboardTable />} />
          <Route
            path="app/wod/training-history"
            element={<TrainingHistoryList />}
          />
          <Route
            path="app/wod/memberships"
            element={<MembershipsLandingPage />}
          />
          <Route path="app/wod/templates" element={<TemplateTable />} />
          <Route
            path="app/wod/templates/:identifier"
            element={<TemplateDetails />}
          />
          <Route
            path="app/wod/templates/:identifier/edit"
            element={<TemplateForm />}
          />
          <Route
            path="app/wod/templates/create-form"
            element={<TemplateForm />}
          />
          <Route path="app/wod/templates/import" element={<ImportWODTemplates />} />
          <Route path="app/wod/my-details" element={<WODMyDetails />} />
          <Route
            path="app/wod/members/:identifier"
            element={<WODProfileDetails />}
          />
          <Route
            path="app/wod/settings/payments/connect-stripe"
            element={<ConnectStripe />}
          />
          <Route
            path="app/wod/membership/payments/success"
            element={<PaymentSuccess />}
          />
          <Route
            path="app/wod/membership/payments/cancelled"
            element={<PaymentCancel />}
          />
          <Route
            path="app/wod/settings/payments/connect-stripe"
            element={<ConnectStripe />}
          />
          <Route
            path="app/wod/settings/payments"
            element={<PaymentLandingPage />}
          />
          <Route
            path="app/wod/settings/products/create-form"
            element={<WODProductForm />}
          />
          <Route
            path="app/wod/settings/products/:identifier/edit"
            element={<WODProductForm />}
          />
          <Route
            path="app/wod/settings/products/:identifier"
            element={<WODProductDetails />}
          />
          <Route
            path="app/wod/settings/athletes/create-form"
            element={<AthleteForm />}
          />
          <Route
            path="app/wod/settings/athletes/:identifier"
            element={<AthleteForm />}
          />
          <Route
            path="app/wod/personal-records"
            element={<PersonalRecords />}
          />
          <Route path="app/wod/goals" element={<WODGoalTable />} />
          <Route path="app/wod/goals/create-form" element={<WODGoalForm />} />
          <Route
            path="app/wod/goals/:identifier/edit"
            element={<WODGoalForm />}
          />
          <Route path="app/wod/members" element={<WODMembers />} />
          <Route
            path="app/wod/members/import"
            element={<ImportWODMembersPage />}
          />
          <Route
            path="app/wod/members/history/import"
            element={<ImportWODMembersHistoryPage />}
          />
            <Route
            path="app/wod/members/create-form"
            element={<WODProfileDetails />}
          />
          <Route
            path="app/wod/goals/:identifier"
            element={<WODGoalDetails />}
          />
          <Route
            path="app/equipments/:identifier/edit"
            element={<EquipmentForm />}
          />
          <Route
            path="app/equipments/create-form"
            element={<EquipmentForm />}
          />
          <Route path="app/support/tickets" element={<SupportTicketList />} />
          <Route
            path="app/support/tickets/:identifier"
            element={<SupportTicketDetails />}
          />
          <Route
            path="app/support/tickets/:identifier/edit"
            element={<SupportTicketForm />}
          />
          <Route
            path="app/support/tickets/create-form"
            element={<SupportTicketForm />}
          />
          /* Admin routes */
          <Route path="app/root/account" element={<AccountList />} />
          <Route
            path="app/root/account/:identifier"
            element={<RootAccountDetails />}
          />
          <Route
            path="app/root/account/:identifier/edit"
            element={<AccountForm />}
          />
          <Route
            path="app/root/account/create-form"
            element={<AccountForm />}
          />
          <Route path="events/event-detail" element={<EventDetail />} />
          <Route path="events/create-an-event" element={<CreateEvent />} />
          <Route path="events/event-list" element={<EventList />} />
          <Route path="app/budget" element={<BudgetLandingPage />} />
          <Route path="app/expense" element={<ExpensesLandingPage />} />
          <Route path="app/invoices" element={<InvoicesLandingPage />} />
          <Route
            path="app/invoices/create-invoice"
            element={<InvoiceDetails />}
          />
          <Route
            path="app/annoucements/custom-list"
            element={<AnnoucementList />}
          />
          <Route
            path="app/annoucements/:identifier"
            element={<AnnoucementDetails />}
          />
          <Route
            path="app/annoucements/create-form"
            element={<AnnoucementForm />}
          />
          <Route path="app/annoucements" element={<AnnoucementList />} />
          <Route
            path="app/annoucements/:identifier/edit"
            element={<AnnoucementForm />}
          />
          <Route path="app/custom/custom-list" element={<CustomList />} />
          <Route path="app/custom/:identifier" element={<CustomDetails />} />
          <Route path="app/custom/create-form" element={<CustomForm />} />
          <Route path="app/custom" element={<CustomLandingPage />} />
          <Route path="app/custom/:identifier/edit" element={<CustomForm />} />
          <Route path="app/invoices/:identifier" element={<InvoiceDetails />} />
          {/* Performance Management */}
          <Route
            path="/app/performance/"
            element={<PerformanceManagementLandingPage />}
          />
          <Route
            path="/app/performance/create-form"
            element={<PerformanceReviewForm />}
          />
          <Route
            path="app/performance/:identifier/edit"
            element={<PerformanceReviewForm />}
          />
          <Route path="/app/performance/goal-form" element={<GoalForm />} />
          <Route path="/app/performance/goal-list" element={<GoalList />} />
          <Route
            path="app/performance/goal/:identifier/edit"
            element={<GoalForm />}
          />
          <Route
            path="/app/performance/feedback-form"
            element={<FeedbackForm />}
          />
          <Route
            path="/app/performance/feedback-form/:identifier/edit"
            element={<FeedbackForm />}
          />
          <Route
            path="/app/performance/feedback-request-form"
            element={<FeedbackRequestForm />}
          />
          <Route path="/app/performance/feedbacks" element={<FeedbackList />} />
          {/* Email */}
          <Route path="email/email-detail" element={<EmailDetail />} />
          <Route path="email/inbox" element={<Inbox />} />
          <Route path="email/compose" element={<Compose />} />
          {/*Pages*/}
          <Route path="pages/starter" element={<Starter />} />
          <Route path="user/profile" element={<Profile />} />
          <Route path="user/settings" element={<BSTSettings />} />
          <Route path="user/account-details" element={<AccountDetails />} />
          <Route path="miscellaneous/associations" element={<Associations />} />
          <Route path="faq/faq-alt" element={<FaqAlt />} />
          <Route path="faq/faq-basic" element={<FaqBasic />} />
          <Route path="faq/faq-accordion" element={<FaqAccordion />} />
          <Route path="pricing/pricing-default" element={<PricingDefault />} />
          <Route path="pricing/pricing-alt" element={<PricingAlt />} />
          <Route
            path="miscellaneous/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="miscellaneous/invite-people"
            element={<InvitePeople />}
          />
          {/* charts-example */}
          <Route path="charts/chartjs" element={<Chartjs />} />
          <Route path="charts/echarts/line-charts" element={<LineCharts />} />
          <Route path="charts/echarts/bar-charts" element={<BarCharts />} />
          <Route
            path="charts/echarts/candlestick-charts"
            element={<CandlestickCharts />}
          />
          <Route path="charts/echarts/geo-map" element={<GeoMaps />} />
          <Route
            path="charts/echarts/scatter-charts"
            element={<ScatterCharts />}
          />
          <Route path="charts/echarts/pie-charts" element={<PieCharts />} />
          <Route path="charts/echarts/radar-charts" element={<RadarCharts />} />
          <Route
            path="charts/echarts/heatmap-charts"
            element={<HeatmapCharts />}
          />
          <Route path="charts/echarts/how-to-use" element={<HowToUse />} />
          {/*Components*/}
          <Route path="components/alerts" element={<Alerts />} />
          <Route path="components/accordion" element={<Accordion />} />
          <Route path="components/animated-icons" element={<AnimatedIcons />} />
          <Route path="components/badges" element={<Badges />} />
          <Route path="components/breadcrumb" element={<Breadcrumbs />} />
          <Route path="components/buttons" element={<Buttons />} />
          <Route path="components/calendar" element={<CalendarExample />} />
          <Route path="components/cards" element={<Cards />} />
          <Route path="components/dropdowns" element={<Dropdowns />} />
          <Route path="components/list-group" element={<ListGroups />} />
          <Route path="components/modals" element={<Modals />} />
          <Route path="components/offcanvas" element={<Offcanvas />} />
          <Route path="components/pagination" element={<Pagination />} />
          <Route
            path="components/progress-bar"
            element={<BasicProgressBar />}
          />
          <Route path="components/placeholder" element={<Placeholder />} />
          <Route path="components/spinners" element={<Spinners />} />
          <Route path="components/toasts" element={<Toasts />} />
          <Route path="components/pictures/avatar" element={<Avatar />} />
          <Route path="components/pictures/images" element={<Image />} />
          <Route path="components/pictures/figures" element={<Figures />} />
          <Route path="components/pictures/hoverbox" element={<Hoverbox />} />
          <Route path="components/pictures/lightbox" element={<Lightbox />} />
          <Route path="components/tooltips" element={<Tooltips />} />
          <Route path="components/popovers" element={<Popovers />} />
          <Route path="components/draggable" element={<DraggableExample />} />
          <Route path="components/scrollspy" element={<Scrollspy />} />
          <Route path="components/timeline" element={<Timeline />} />
          <Route path="components/treeview" element={<TreeviewExample />} />
          <Route
            path="components/carousel/bootstrap"
            element={<BootstrapCarousel />}
          />
          <Route path="components/carousel/slick" element={<SlickCarousel />} />
          <Route path="components/navs-and-tabs/navs" element={<Navs />} />
          <Route path="tables/basic-tables" element={<Tables />} />
          <Route
            path="tables/advance-tables"
            element={<AdvanceTableExamples />}
          />
          <Route path="forms/basic/form-control" element={<FormControl />} />
          <Route path="forms/basic/input-group" element={<InputGroup />} />
          <Route path="forms/basic/select" element={<Select />} />
          <Route path="forms/basic/checks" element={<Checks />} />
          <Route path="forms/basic/range" element={<Range />} />
          <Route path="forms/basic/layout" element={<FormLayout />} />
          <Route path="forms/advance/date-picker" element={<DatePicker />} />
          <Route path="forms/advance/editor" element={<Editor />} />
          <Route
            path="forms/advance/emoji-button"
            element={<EmojiMartExample />}
          />
          <Route
            path="forms/advance/advance-select"
            element={<AdvanceSelect />}
          />
          <Route
            path="forms/advance/file-uploader"
            element={<FileUploader />}
          />
          <Route path="forms/advance/rating" element={<Rating />} />
          <Route path="forms/floating-labels" element={<FloatingLabels />} />
          <Route path="forms/validation" element={<FormValidation />} />
          <Route path="forms/wizard" element={<WizardForms />} />
          <Route path="components/navs-and-tabs/navbar" element={<Navbars />} />
          <Route path="components/navs-and-tabs/tabs" element={<Tabs />} />
          <Route path="components/collapse" element={<Collapse />} />
          <Route
            path="components/cookie-notice"
            element={<CookieNoticeExample />}
          />
          <Route path="components/countup" element={<CountUp />} />
          <Route path="components/videos/embed" element={<Embed />} />
          <Route
            path="components/videos/react-player"
            element={<ReactPlayerExample />}
          />
          <Route path="components/background" element={<Background />} />
          <Route path="components/search" element={<Search />} />
          <Route path="components/typed-text" element={<TypedText />} />
          <Route
            path="components/navs-and-tabs/vertical-navbar"
            element={<VerticalNavbar />}
          />
          <Route
            path="components/navs-and-tabs/top-navbar"
            element={<NavBarTop />}
          />
          <Route
            path="components/navs-and-tabs/combo-navbar"
            element={<ComboNavbar />}
          />
          {/*Utilities*/}
          <Route path="utilities/borders" element={<Borders />} />
          <Route path="utilities/colors" element={<Colors />} />
          <Route path="utilities/colored-links" element={<ColoredLinks />} />
          <Route path="utilities/display" element={<Display />} />
          <Route path="utilities/visibility" element={<Visibility />} />
          <Route path="utilities/stretched-link" element={<StretchedLink />} />
          <Route path="utilities/stretched-link" element={<StretchedLink />} />
          <Route path="utilities/float" element={<Float />} />
          <Route path="utilities/position" element={<Position />} />
          <Route path="utilities/spacing" element={<Spacing />} />
          <Route path="utilities/sizing" element={<Sizing />} />
          <Route
            path="utilities/text-truncation"
            element={<TextTruncation />}
          />
          <Route path="utilities/typography" element={<Typography />} />
          <Route path="utilities/vertical-align" element={<VerticalAlign />} />
          <Route path="utilities/flex" element={<Flex />} />
          <Route path="utilities/grid" element={<Grid />} />
          <Route path="utilities/scroll-bar" element={<Scrollbar />} />
          <Route path="widgets" element={<Widgets />} />
          {/*Documentation*/}
          <Route
            path="documentation/getting-started"
            element={<GettingStarted />}
          />
          <Route
            path="documentation/configuration"
            element={<Configuration />}
          />
          <Route path="documentation/styling" element={<Styling />} />
          <Route path="documentation/dark-mode" element={<DarkMode />} />
          <Route path="documentation/plugin" element={<Plugins />} />
          <Route path="documentation/faq" element={<Faq />} />
          <Route path="documentation/design-file" element={<DesignFile />} />
          <Route path="changelog" element={<Changelog />} />
          <Route path="authentication-modal" element={<ModalAuth />} />
        </Route>

        {/* //--- MainLayout end  */}

        {/* <Navigate to="/errors/404" /> */}
        <Route path="*" element={<Navigate to="/errors/404" replace />} />
      </Routes>
      <SettingsToggle />
      <SettingsPanel />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.BOTTOM_LEFT}
      />
    </>
  );
};

export default Layout;
